import {api} from '@/services/http/api'
import {BaseResponse} from '@/interfaces'
import {
  ContainerTypesResponse,
  Order,
  OrderDetailsResponse,
  OrderExplanationsResponse,
  OrdersResponse,
  SpecialOrdersResponse,
} from '@/services/http/orders/models/Order'
import {
  OrderCloseParams,
  PostFiltersParams,
  SpecialOrderCloseParams,
} from '@/services/http/orders/models/dtos'

const OrdersService = {
  postFilters: async (params: PostFiltersParams) => {
    try {
      const response = await api.post<BaseResponse<OrdersResponse | null>>(
        '/v1/ordemservico',
        params,
      )
      return response.data
    } catch (error) {
      throw error
    }
  },

  getOrderDetails: async (orderId: number, signal: AbortSignal) => {
    try {
      const response = await api.post<
        BaseResponse<OrderDetailsResponse | null>
      >('/v1/ordemservico/detalhes-os', {idOs: orderId}, {signal})
      return response.data
    } catch (error) {
      throw error
    }
  },

  getOrderExplanations: async () => {
    try {
      const response = await api.get<BaseResponse<OrderExplanationsResponse>>(
        '/v1/ordemservico/parametro-justificativa-provedor',
      )
      return response.data
    } catch (error) {
      throw error
    }
  },

  getContainerTypes: async () => {
    try {
      const response = await api.get<BaseResponse<ContainerTypesResponse>>(
        '/v1/ordemservico/container-tipos',
      )
      return response.data
    } catch (error) {
      throw error
    }
  },
  closeOrder: async (orderClosure: OrderCloseParams) => {
    try {
      const response = await api.put<BaseResponse<null>>(
        '/v1/ordemservico/fechar-os',
        orderClosure,
      )
      return response.data
    } catch (error) {
      throw error
    }
  },
  closeSpecialOrders: async (orders: SpecialOrderCloseParams) => {
    try {
      const response = await api.put<
        BaseResponse<SpecialOrdersResponse | null>
      >('/v1/ordemservico/fechar-os-lista', orders)
      return response.data
    } catch (error) {
      throw error
    }
  },
  exportAsXls: async (orders: Order[]) => {
    const response = await api.post<ArrayBuffer>(
      '/v1/ordemservico/export',
      orders,
      {
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/vnd.ms-excel',
        },
      },
    )
    return response.data
  },
}

export default OrdersService
